'use client'

import { Button, Cell, Dialog, Spacer, Text } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { clickEvent } from '@marketplace-web/catalog/catalog-page-data'
import { HelpCenterFaqEntryUrl } from '@marketplace-web/help-center/help-center-faq-entry-url-feature'
import {
  AccessChannel,
  FaqEntryType,
} from '@marketplace-web/help-center/help-center-faq-entry-url-data'

import { OUR_PLATFORM_URL } from '../../../../constants/routes'

type Props = {
  show: boolean
  onConfirmOrClose: () => void
}

const SearchResultsRankingModal = ({ show, onConfirmOrClose }: Props) => {
  const translate = useTranslate('catalog.search_results.ranking_modal')
  const { track } = useTracking()

  const handleSearchResultsLearnMoreClick = () => {
    track(clickEvent({ target: 'help_center_search_result' }))
  }

  const handleBumpsLearnMoreClick = () => {
    track(clickEvent({ target: 'push_up_learn_more' }))
  }

  const renderBody = () => (
    <Cell styling="tight">
      <Text as="h2" text={translate('subtitle')} type="title" />
      <Spacer size="medium" />
      <Text as="span" html text={translate('body.one')} type="body" />
      <Spacer size="medium" />
      <Text as="span" html text={translate('body.two')} type="body" />
      <Spacer size="medium" />
      <a
        href={OUR_PLATFORM_URL}
        onClick={handleSearchResultsLearnMoreClick}
        target="_blank"
        rel="noreferrer"
      >
        {translate('link')}
      </a>
      <Spacer size="x3-large" />
      <Text as="h2" text={translate('bumps.subtitle')} type="title" />
      <Spacer size="medium" />
      <Text as="span" html text={translate('bumps.body')} type="body" />
      <Spacer size="medium" />
      <HelpCenterFaqEntryUrl
        type={FaqEntryType.Bump}
        accessChannel={AccessChannel.ProductLink}
        render={url => (
          <a
            data-testid="bumps-faq-link"
            href={url}
            onClick={handleBumpsLearnMoreClick}
            target="_blank"
            rel="noreferrer"
          >
            {translate('bumps.link')}
          </a>
        )}
      />
      <Spacer size="x3-large" />
      <Button
        text={translate('actions.confirm')}
        styling="filled"
        size="medium"
        onClick={onConfirmOrClose}
      />
      <Spacer size="medium" />
    </Cell>
  )

  return (
    <Dialog
      enableCloseButton
      hasScrollableContent
      className="search-results-ranking-modal"
      body={renderBody()}
      defaultCallback={onConfirmOrClose}
      show={show}
      testId="search-results-ranking-modal"
      title={translate('title')}
    />
  )
}

export default SearchResultsRankingModal
